export const qcTasksState = {
    name: 'app.qcTasks',
    url: '/qc-tasks',
    component: 'qcTasks'
};
